import styled from 'styled-components/macro';

export default {
	Container: styled.div`
		display: flex;
		flex-flow: column nowrap;
		max-width: 500px;
		width: 100%;
	`
};
